import React, {useMemo} from 'react';
import {P11MatchItem} from '../../home.service';
// @ts-ignore
import {getImageUrl} from '@/utils/image';
import {Countdown} from './countdown';

// Format date and time
function formatDateTime(timestamp: number | string | undefined): {
  date: string;
  time: string;
} {
  if (!timestamp) {
    return {date: '', time: ''};
  }
  const date = new Date(+timestamp);
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const tomorrow = new Date(today);
  tomorrow.setDate(tomorrow.getDate() + 1);
  const targetDate = new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDate(),
  );

  let dateStr = '';
  if (targetDate.getTime() === today.getTime()) {
    dateStr = 'Today';
  } else if (targetDate.getTime() === tomorrow.getTime()) {
    dateStr = 'Tomorrow';
  } else {
    dateStr = date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
    });
  }

  const hours = date.getHours();
  const minutes = date.getMinutes();
  const ampm = hours >= 12 ? 'PM' : 'AM';
  const hours12 = hours % 12 || 12;
  const timeStr = `${hours12}:${minutes.toString().padStart(2, '0')} ${ampm}`;
  return {date: dateStr, time: timeStr};
}

export function Pick11NewCard({
  match,
  onClick,
}: {
  match: P11MatchItem;
  onClick: () => void;
}) {
  const {time} = useMemo(
    () => formatDateTime(match.dateStart),
    [match.dateStart],
  );
  const prizePoolDisplay = useMemo(
    () => match.maxPrizePool?.toLocaleString('en-IN') ?? '0',
    [match.maxPrizePool],
  );

  const teamALogo = match.teamaLogoUrl ? getImageUrl(match.teamaLogoUrl) : null;
  const teamBLogo = match.teambLogoUrl ? getImageUrl(match.teambLogoUrl) : null;

  /** 第三块：底部（Figma 1222-8133） */
  function Block3Footer({prizePoolDisplay}: {prizePoolDisplay: string}) {
    return (
      <div className="flex w-full text-[#727272] font-inter text-xs font-bold">
        EST.MEGA ₹{prizePoolDisplay}
      </div>
    );
  }

  return (
    <div
      className="w-full cursor-pointer p-3 rounded-lg border border-[#E6E8EA] bg-white shadow-[0_8px_16px_0_rgba(0,0,0,0.04)] relative flex flex-col gap-2"
      onClick={onClick}>
      {/* Header */}
      <div className="flex justify-between items-center gap-2">
        <div className="flex items-center gap-1  text-sm text-[#18181B]">
          <div className="flex whitespace-nowrap text-ellipsis overflow-hidden flex-1">
            {match.fantasyCompetitionTitle}
          </div>
          <img
            src={require('@/assets/imgs/home/arrow_right.webp')}
            alt=">"
            className="w-3 h-3"
          />
        </div>
        <div className="flex items-center">
          <img
            src={require('@/assets/imgs/home/pick_logo.webp')}
            alt="Pick11"
            className="w-4 h-4"
          />
        </div>
      </div>

      {/* Content */}
      <div className="flex p-2 items-center gap-3 self-stretch rounded-lg bg-[#F8F9FB] space-between">
        {/* Left: Teams */}
        <div className="flex flex-col gap-[6px] flex-1 min-w-0">
          <div className="flex flex-row gap-2 items-center overflow-hidden">
            <img
              src={teamALogo ?? ''}
              alt="Team A Logo"
              className="w-8 h-8 rounded-full flex-shrink-0"
            />
            <div className="text-sm text-t1 font-bold flex-shrink-0">
              {match.teamaShortName}
            </div>
            <div className="text-sm text-t3 font-medium truncate">
              {match.teamaName}
            </div>
          </div>
          <div className="flex flex-row gap-2 items-center overflow-hidden">
            <img
              src={teamBLogo ?? ''}
              alt="Team B Logo"
              className="w-8 h-8 rounded-full flex-shrink-0"
            />
            <div className="text-sm text-t1 font-bold flex-shrink-0">
              {match.teambShortName}
            </div>
            <div className="text-sm text-t3 font-medium truncate">
              {match.teambName}
            </div>
          </div>
        </div>
        <div className='relative pl-6 before:content-[""] before:absolute before:left-0 before:top-0 before:h-full before:w-[1px] before:bg-[#E6E8EA]'>
          <div className="flex flex-col items-center justify-center h-full gap-1">
            {match.status === 'upcoming' && match.dateStart && (
              <Countdown startTime={match.dateStart} endTime={match.dateEnd} />
            )}
            <span className="text-[#000] text-xs font-medium letter-spacing-[-0.3px]">
              {time}
            </span>
          </div>
        </div>
      </div>

      {/* Footer */}
      <Block3Footer prizePoolDisplay={prizePoolDisplay} />
    </div>
  );
}
